export default class DeleteCallRecording {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId }) {
    this.context.gateways.voiceRecording.deleteCallRecording(customerId, conversationItemId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation_item/voice_recording/delete_call_recording.js